import { Menu, MenuButton, MenuList, MenuItem, Button, Icon, Box } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { MessageSquare, ChevronDown, X } from 'lucide-react';
import { useMemo } from 'react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

export function MessageTypeFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const filterLabel = useMemo(() => {
    if (filters.messageType === 'support') {
      return t`Duke Support`;
    }
    if (filters.messageType === 'student') {
      return t`Participants`;
    }
    return t`All Messages`;
  }, [filters.messageType]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<Icon as={MessageSquare} boxSize={4} />}
        rightIcon={
          filters.messageType !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ messageType: undefined });
              }}
              ml={1}
            >
              <X size="16px" />
            </Box>
          ) : (
            <ChevronDown size="16px" />
          )
        }
        variant="ghost"
        size="sm"
        fontWeight="normal"
        px={3}
      >
        {filterLabel}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => updateFilters({ messageType: undefined })}>
          <Trans>All Messages</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ messageType: 'support' })}>
          <Trans>Duke Support</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ messageType: 'student' })}>
          <Trans>Participants</Trans>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
